import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TrendingUp, Shield, Flame, BarChart3 } from 'lucide-react';

const SC = {
  base: { icon: BarChart3, color: 'text-blue-500', border: 'border-blue-500/30', bg: 'bg-blue-500/[0.04]' },
  optimistic: { icon: TrendingUp, color: 'text-emerald-500', border: 'border-emerald-500/30', bg: 'bg-emerald-500/[0.04]' },
  conservative: { icon: Shield, color: 'text-amber-500', border: 'border-amber-500/30', bg: 'bg-amber-500/[0.04]' },
  stress_test: { icon: Flame, color: 'text-red-500', border: 'border-red-500/30', bg: 'bg-red-500/[0.04]' },
};

export default function ScenarioCards({ scenarios }) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState('base');
  if (!scenarios) return null;

  return (
    <div data-testid="scenario-cards" className="bg-white dark:bg-[#0F1419] border border-slate-200 dark:border-white/[0.06] rounded-xl p-5">
      <h3 className="font-semibold text-sm text-slate-900 dark:text-white mb-4">{t('decision.scenarios')}</h3>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {['base', 'optimistic', 'conservative', 'stress_test'].map(name => {
          const d = scenarios[name];
          const c = SC[name];
          const Icon = c.icon;
          const cfColor = d.monthly_cash_flow >= 0 ? 'text-emerald-500' : 'text-red-500';
          const sel = selected === name;
          return (
            <button key={name} data-testid={`scenario-card-${name}`} onClick={() => setSelected(name)}
              className={`text-left p-4 rounded-xl border-2 transition-all ${c.bg} ${sel ? c.border : 'border-transparent hover:border-slate-200 dark:hover:border-white/10'}`}>
              <div className="flex items-center gap-1.5 mb-3">
                <Icon className={`w-3.5 h-3.5 ${c.color}`} />
                <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400">{t(`decision.sc_${name}`)}</span>
              </div>
              <p className="text-[10px] text-slate-400 mb-0.5">{t('decision.cashFlow')}</p>
              <p className={`text-lg font-black tabular-nums ${cfColor}`}>
                {d.monthly_cash_flow >= 0 ? '+' : ''}${Math.round(d.monthly_cash_flow).toLocaleString()}
              </p>
              <div className="grid grid-cols-2 gap-2 mt-2">
                <div>
                  <p className="text-[10px] text-slate-400">{t('analyze.capRate')}</p>
                  <p className="text-sm font-bold text-slate-900 dark:text-white tabular-nums">{d.cap_rate.toFixed(1)}%</p>
                </div>
                <div>
                  <p className="text-[10px] text-slate-400">DSCR</p>
                  <p className={`text-sm font-bold tabular-nums ${d.dscr >= 1 ? 'text-emerald-500' : 'text-red-500'}`}>{d.dscr.toFixed(2)}</p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
      <p className="text-[10px] text-slate-400 mt-3 italic">{t('aiEngine.scenarioNote')}</p>
    </div>
  );
}
